import { useMutation } from '@apollo/client'
import gql from 'graphql-tag'
import { NewUserInput, UserMutationOutput } from 'epc-schema'
/**
 * This mutation will update the user's profile upon
 * form submission.
 */
const CREATE_USER_MUTATION = gql`
  mutation CreateUser($userInput: NewUserInput!) {
    response: createUser(userInput: $userInput) {
      errors {
        message
        path
      }
      success
    }
  }
`

export const useCreateUser = () =>
  useMutation<{
    response: UserMutationOutput
    userInput: NewUserInput
  }>(CREATE_USER_MUTATION)
